import React, { Component } from 'react';
import { Translation } from 'react-i18next';

function Ans3() {
  return (
    <Translation>
      {(t) => (
        <div className="bg">
          <ol className="ans">
            <li>
              <b className="fisrt-line">{t('ans_3.text_1')}</b>
              <p>{t('ans_3.text_2')}</p>
            </li>
            <li>
              <b className="fisrt-line">{t('ans_3.text_3')}</b>
              <p>{t('ans_3.text_4')}</p>
            </li>
          </ol>
        </div>
      )}
    </Translation>
  );
}

export default Ans3;
